import { chain } from 'lodash';
const NFC_SETTINGS_KEY = 'nfc_settings';

export default function getSettingsItem(key) {
  return chain(localStorage.getItem(NFC_SETTINGS_KEY))
    .thru(v => (v ? JSON.parse(v) : v))
    .get(key, {})
    .value();
}
